import conf from '../../../infra/config.js';

export const PENDO_API_KEY = '5c48f771-49fc-4fa3-4b92-3a7147e3246a';
// eslint-disable-next-line no-undef
export const isDisabled = () => !conf.isProductionOrNext;

const addPendoScript = function (p, e, n, d, o) {
  let v, w, x, y, z;
  o = p[d] = p[d] || {};
  o._q = o._q || [];
  v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
  for (w = 0, x = v.length; w < x; ++w)
    (function (m) {
      o[m] =
        o[m] ||
        function () {
          o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
        };
    })(v[w]);
  y = e.createElement(n);
  y.async = !0;
  y.src = 'https://cdn.pendo.io/agent/static/' + PENDO_API_KEY + '/pendo.js';
  z = e.getElementsByTagName(n)[0];
  z.parentNode.insertBefore(y, z);
};

export const initialize = (user) => {
  try {
    if (user.permissions.find((p) => p.name === 'block pendo tracking') || isDisabled()) {
      return;
    }

    // Initialize Pendo
    addPendoScript(window, document, 'script', 'pendo');
    window.pendo.initialize({
      visitor: {
        id: user.id,
        email: user.email,
      },
      account: {
        id: `discovery-${user.account.id}`,
        name: user.account.name,
      },
    });
  } catch (error) {
    console.error('Pendo tracking blocked due to error', {
      userId: user?.id,
      error: error.message,
      reason: 'initialization_error',
    });
  }
};
